export default "__VITE_PUBLIC_ASSET__56b6f0fd__"